export class ApiError extends Error { constructor(readonly status: number, message: string) { super(message) } }

export class ApiClient {
  constructor(private readonly baseUrl = '') {}
  async request<T>(path: string, init?: RequestInit): Promise<T> {
    const response = await fetch(`${this.baseUrl}${path}`, { ...init, credentials: 'same-origin' })
    if (!response.ok) throw new ApiError(response.status, await response.text())
    if (response.status === 204) return undefined as T
    return response.json() as Promise<T>
  }
}
